import React from 'react';

import {ProductSeatUpdateResultModal} from 'src/modules/bulk-update/product-seat-update-result.modal';
import {
    getProductSeatUnassignBulkProgress,
    getProductSeatUnassignBulkResult,
} from 'src/openapi/admin/apis/BulkProductSeatUnassignmentApi';
import {useAppDispatch} from 'src/store/hooks';

import {FILE_HEADERS, FILE_NAME, TOOL_TITLE} from './constants';

type Props = {id: string, onClose: () => void};
export const UnassignProductSeatResultModal = ({id, onClose}: Props) => {
    const apiDispatch = useAppDispatch();
    return (
        <ProductSeatUpdateResultModal
            id={id}
            onClose={onClose}
            toolTitle={TOOL_TITLE}
            fileName={FILE_NAME}
            fileHeaders={FILE_HEADERS}
            getProgress={resultId => apiDispatch(getProductSeatUnassignBulkProgress({id: resultId}))}
            getResult={resultId => apiDispatch(getProductSeatUnassignBulkResult({id: resultId}))}
        />
    );
};
